import React, { Component } from "react";
import { connect } from "react-redux";
import { List, Map } from "immutable";

// Components
import Select from "../../components/common/virtualized-select";
import Loading from "../common/Loading";

// Actions
import { cleanPurchaseOrders, getPurchaseOrders } from "../../actions/purchase-orders";

class AddPurchaseOrderDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            order: -1,
            orders: List([])
        }
    }

    componentDidMount() {
        this.props.onRef(this);
        this.props.getPurchaseOrders({
            projection: 'order_code'
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let orders = this.props.orders;
        if (orders !== prevProps.orders) {
            if (orders instanceof List) {
                this.setState({ orders });
            }
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
        this.props.cleanPurchaseOrders();
    }

    onAddButtonClick = () => {
        if (this.state.order !== -1) {
            const purchaseOrders = this.props.project.get('purchase_orders').toJS() || [];
            purchaseOrders.push(this.state.order);
            this.props.updateProject(this.props.project.get('_id'), {
                purchase_orders: purchaseOrders
            });
        }
        this.props.onCloseModal();
    }

    validate = () => {
        this.props.onCanSubmit(this.state.order !== -1);
    }

    render() {
        const ordersData = this.props.purchaseOrders;
        const ordersIsFetching = this.props.purchaseOrdersIsFetching;

        if (ordersIsFetching) return <Loading show={ordersIsFetching} />

        return (
            <div className="row modal-row">
                <div className="col">
                    <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Pedido</label>
                    <Select
                        className="virtualized-select"
                        options={ordersData.toJS()}
                        value={this.state.order}
                        labelKey="select"
                        valueKey="_id"
                        matchProp="select"
                        multi={false}
                        searchable={true}
                        onChange={(order) => {
                            if (order) {
                                this.setState({ order: order._id }, this.validate);
                            }
                        }}
                    />
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    // Reducers
    const purchaseOrdersReducer = state.purchaseOrders;
    const projectReducer = state.projects;

    // Get purchase orders from project to filter purchase orders list
    const project = projectReducer.get('payload');
    const projectPurchaseOrders = project.get('purchase_orders');

    // Purchase orders
    let purchaseOrders = purchaseOrdersReducer.get('payload') || List([]);;
    if (!(purchaseOrders instanceof List)) purchaseOrders = List([]);
    if (purchaseOrders.size > 0) {
        purchaseOrders = purchaseOrders.filter(po => {
            return !projectPurchaseOrders.some(order => order.get('_id') === po.get('_id'));
        });
        purchaseOrders = purchaseOrders.map(po => po.set('select', po.get('order_code')));
    }
    purchaseOrders = purchaseOrders.insert(0, Map({ _id: -1, select: 'Selecciona un pedido' }));

    const purchaseOrdersIsFetching = purchaseOrdersReducer.get('isFetching');

    return {
        purchaseOrders, purchaseOrdersIsFetching
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getPurchaseOrders: query => dispatch(getPurchaseOrders(query)),
        cleanPurchaseOrders: () => dispatch(cleanPurchaseOrders())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddPurchaseOrderDialog);


// WEBPACK FOOTER //
// ./src/components/dialogs/AddPurchaseOrderDialog.js